import { Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { FcViewDetails } from 'react-icons/fc';
import { useNavigate } from 'react-router-dom';
import Toast from '../../helpers/Toast';
import { CreateEquipmentDTO } from '../../models/Equipment/CreateEquipmentDTO';
import { EquipmentsFromProjectRequestDTO } from '../../models/Project/EquipmentsFromProjectRequestDTO';
import { EquipmentsFromProjectResponseDTO } from '../../models/Project/EquipmentsFromProjectResponseDTO';
import { EquipmentService } from '../../services/EquipmentService';
import { ProjectService } from '../../services/ProjectService';
import TableComponent from '../TableComponent';

type  EquipmentsFromProjectProps = {
    ProjectErp: string,
}

function EquipmentsFromProject(props: EquipmentsFromProjectProps) {
    
    const equipmentService = new EquipmentService();
    const projectService = new ProjectService();
    const navigate = useNavigate();
    const [equipments, setEquipments] = useState<EquipmentsFromProjectResponseDTO[]>([]);
    const pageSizes: number[] = [5, 15, 30];
    const [pageSize, setPageSize] = useState<number>(pageSizes[0]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [goToPage, setGoToPage] = useState<number>();
    const [pageCount, setPageCount] = useState(1);
    const [isButtonCreateLoading, setIsButtonCreateLoading] = useState<boolean>(false);

    const columns = React.useMemo(
        () => [
            {
                Header: "Código",
                accessor: "erpId",
                width: 12,
            },
            {
                Header: "Nº Série",
                accessor: "serialNumber",
                width: 12,
            },
            {
                Header: "Marca",
                accessor: "brand",
                width: 12,
            },
            {
                Header: "Modelo",
                accessor: "model",
                width: 12,
            },
            {
                Header: "",
                accessor: " ",
                Cell: (props: any) => {
                    return (
                        <Tooltip
                            title="Ver Detalhes"
                            aria-label="Ver Detalhes"
                            enterNextDelay={500}
                            enterDelay={500}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    alignContent: "center",
                                    flexDirection: "column",
                                    cursor: "pointer"
                                }}
                                onClick={() => {
                                    // Verificamos se cada campo 'relacionado' existe antes de passar para a função
                                    const erpId = props.cell.row.original.erpId || null;
                                    const name = props.cell.row.original.name || null;
                                    const carPlate = props.cell.row.original.carPlate || null;
                                    const serialNumber = props.cell.row.original.serialNumber || null;
                                    const brand = props.cell.row.original.brand || null;
                                    const model = props.cell.row.original.model || null;
                                    const clientErpId = props.cell.row.original.clientErpId || null;

                                    createEquipment(erpId, name, carPlate, serialNumber, brand, model, clientErpId);
                                }}
                            >
                                <FcViewDetails className="icons" />
                            </div>
                        </Tooltip>
                    );
                },
                width: 2,
            },
           
        ],
        [isButtonCreateLoading],
    );

    const createEquipment = async (erpId: string, name: string, carPlate: string, serialNumber: string, brand: string, model: string, clientErpId: string) => {
        var sendData: CreateEquipmentDTO = {
            erpId: erpId,
            name: name,
            carPlate: carPlate,
            serialNumber: serialNumber,
            brand: brand,
            model: model,
            clientErpId: clientErpId,
        }
        setIsButtonCreateLoading(true);
        var response = await equipmentService.Create(sendData);
        setIsButtonCreateLoading(false);

        if (response.success === false) {
            Toast.Show("error", response.message);
            return;
        }
        navigate(`/Equipment/${response.obj}`);
    }

    const GetEquipments = async (page: number, pageSize: number) => {
        setIsLoading(true);

        const data : EquipmentsFromProjectRequestDTO = {
            projectErp: String(props.ProjectErp),
            currentPage: currentPage,
            pageSize: pageSize,
        }

        var response = await projectService.GetEquipmentsFromProject(data);

        if(response.success === false)
        {
            Toast.Show("error", response.message);
            setIsLoading(false);
            return; 
        }

        setEquipments(response.items);
        setIsLoading(false);
        setPageCount(response.totalPages);
        setPageSize(pageSize);
        setCurrentPage(page);
        setGoToPage(0)
    }

    useEffect(()=> {
        if(props.ProjectErp !== "")
        {
            GetEquipments(currentPage ?? 1, pageSize ?? 5)
        }
    }, [props.ProjectErp, currentPage, pageSize])

  return (
        <div>
            <label style={{ margin: "0px" }}></label>
             <TableComponent 
                    columns={columns} 
                    data={equipments}
                    goToPage={goToPage}
                    initialPage={currentPage}
                    pageCount={pageCount}
                    initialPageSize={pageSize}
                    pageSizes={pageSizes}
                    manualPagination={true}
                    loading={isLoading}
                    fetchData={GetEquipments} 
                    initialSortBy={[]}
                    disableSortBy={true}
                />    
        </div>
    
  )
}

export default EquipmentsFromProject